// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "reservatorio-de-dopamina.firebaseapp.com",
  "projectId": "reservatorio-de-dopamina",
  "storageBucket": "reservatorio-de-dopamina.appspot.com",
  "messagingSenderId": "861326981273",
  "appId": "1:861326981273:web:eea5cfc97213de4870a008",
  "measurementId": "G-S5PWN5BHBT",
  "apiKey": "AIzaSyCagQl826JYpUMeSue548kY3WP74v4DhNA"
};
